import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const UserProfile = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2.5C10.3327 2.5 2.5 10.3327 2.5 20C2.5 29.6673 10.3327 37.5 20 37.5C29.6673 37.5 37.5 29.6673 37.5 20C37.5 10.3327 29.6673 2.5 20 2.5ZM20 9.27419C23.4294 9.27419 26.2097 12.0544 26.2097 15.4839C26.2097 18.9133 23.4294 21.6935 20 21.6935C16.5706 21.6935 13.7903 18.9133 13.7903 15.4839C13.7903 12.0544 16.5706 9.27419 20 9.27419ZM20 33.5484C15.8579 33.5484 12.1462 31.6714 9.6623 28.7359C10.9889 26.2379 13.5857 24.5161 16.6129 24.5161C16.7823 24.5161 16.9516 24.5444 17.1139 24.5938C18.0312 24.8901 18.9909 25.0806 20 25.0806C21.0091 25.0806 21.9758 24.8901 22.8861 24.5938C23.0484 24.5444 23.2177 24.5161 23.3871 24.5161C26.4143 24.5161 29.0111 26.2379 30.3377 28.7359C27.8538 31.6714 24.1421 33.5484 20 33.5484Z"
        fill={color || tailwindConfig.theme.colors.white}
      />
    </svg>
  );
};

export default UserProfile;
